import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { withAuth } from '@okta/okta-react';
import { find, isNil } from 'lodash';
import { routines as modalRoutines } from '../../reducers/ui/modal';
import { currentUserSelector } from '../../reducers/db/user';
import {
  routines as decisionsActions,
  sectionListSelector
} from '../../reducers/db/decisions';
import './style.css';

class Menu extends Component {
  static propTypes = {
    className: PropTypes.string
  };
  static defaultProps = {
    className: ''
  };
  state = {
    isVisible: false
  };
  constructor(props) {
    super(props);
    this.props.getSections();
    this.logout = this.logout.bind(this);
  }
  async logout() {
    localStorage.clear();
    this.props.auth.logout('/logout');
    setTimeout(() => {
      document.location.reload();
    }, 1000);
  }

  handleCancel = e => {
    this.updateTitle();
  };
  handleCreateDashboard = dashboard => {
    this.props.openModal({
      name: 'create-dashboard',
      data: {
        dashboard
      },
      display: {
        opacity: 0.2,
        height: 360,
        width: 420,
        preventAutoClose: true,
        warnFormName: 'createDashboard'
      }
    });
    this.handleHide();
  };
  handleShowDisclosures = () => {
    this.props.openModal({
      name: 'disclosures',
      data: {},
      display: {
        opacity: 0.2,
        height: 500,
        width: 900,
        preventAutoClose: false
      }
    });
    this.handleHide();
  };
  handleChangeClient = dashboard => {
    this.props.openModal({
      name: 'change-deal',
      data: {},
      display: {
        opacity: 0.2,
        height: 360,
        width: 560,
        preventAutoClose: () => {
          var dealId = localStorage.getItem('dealId');
          return isNil(dealId);
        }
      }
    });
    this.handleHide();
  };
  handleShow = () => {
    this.setState(
      {
        isVisible: true
      },
      () => {
        if (!this.clickHandler)
          this.clickHandler = document.addEventListener(
            'click',
            this.handleClick
          );
      }
    );
  };
  handleHide = () => {
    document.removeEventListener('click', this.handleClick);
    delete this.clickHandler;
    this.setState({
      isVisible: false
    });
  };

  handleSectionClick = sectionId => {
    const sections = this.props.sectionsList[0] || [];
    const activeSection = find(sections, s => s.id === sectionId);
    const active = activeSection || [];
    window.localStorage.setItem('section', active.entityName);

    document.removeEventListener('click', this.handleClick);
    delete this.clickHandler;
    this.setState({
      isVisible: false
    });
  };

  handleClick = e => {
    this.handleHide();
  };
  handleStop = e => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
  };
  handleClientDataRoom = e => {
    window.open(
      'https://adamsstreetpartnersext.okta.com/home/adamsstreetpartnersllc_netagedynamo_2/0oa1rh6aappFKgBvk357/aln1rhaehjoSCSIHu357'
    );
  };

  render() {
    const { className, deals = {}, sectionsList = [], dealId } = this.props;
    const { isVisible } = this.state;
    const classList = classNames(className, 'app-menu', {
      'app-menu-visible': isVisible
    });
    const dealList = deals.dealsForGpList || {};
    const activeDeal = find(dealList, deal => deal.salesforceDealID === dealId);
    return (
      <div className={classList} onClick={this.handleStop}>
        <div className="app-menu-preview" onClick={this.handleShow}>
          <div className="app-menu-preview-label">Deals</div>
          <i className="fas fa-bars app-menu-preview-icon" />
        </div>
        <div className="app-menu-nav" onClick={this.handleHide}>
          <i className="app-menu-nav-close-button fas fa-times" />
          <div className="app-menu-nav-label">Main Menu</div>
        </div>
        <div className="app-menu-container">
          <div className="app-menu-header">
            <div className="app-menu-subtitle">
              {localStorage.getItem('active-user-id') || ''}
            </div>
            <br />
            <div className="app-menu-subtitle">
              {activeDeal ? activeDeal.dealName : 'No Deal Selected'}
            </div>
            <div
              className="app-menu-change-client-button"
              onClick={this.handleChangeClient}>
              Change Deals
            </div>
          </div>
        </div>
        <div className="app-menu-section">
          <div className="app-menu-section-title">Sections</div>
          <div className="app-menu-list">
            {sectionsList.map((prop, key) => {
              return (
                <div key={key}>
                  {sectionsList[key].map(dataItem => {
                    return (
                      <NavLink
                        className="app-menu-list-item"
                        key={dataItem.id}
                        to={`/dashboard/${dataItem.id}`}
                        onClick={() => this.handleSectionClick(dataItem.id)}>
                        <i className="fas fa-file app-menu-list-item-icon" />
                        <span>{dataItem.entityName}</span>
                      </NavLink>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
        <div className="app-menu-footer">
          <div
            className="app-menu-client-data-room-button"
            onClick={this.logout}>
            <span>Logout</span>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    sectionsList: sectionListSelector(state, props),
    currentUser: currentUserSelector(state, props)
  };
};

const mapDispatchToProps = {
  openModal: modalRoutines.openModal,
  closeModal: modalRoutines.closeModal,
  getSections: decisionsActions.getSections
};

export default withAuth(connect(mapStateToProps, mapDispatchToProps)(Menu));
